module.exports = __webpack_public_path__ + "static/img/qita.3035c0b7.png";